import sortedByDate from "./sorted-by-date";

export default sortedByDate.reduce((groupes, modele, id) => {
  const { row, col } = modele;
  const dimension = `${row}x${col}`;
  const dimensions = groupes[`${dimension}`] || [];
  const no = dimensions.length + 1;
  return {
    ...groupes,
    [`${dimension}`]: [...dimensions, { id, row, col, dimension, no }]
  };
}, {});
